import React, {useState} from 'react';
import {Button, Drawer} from '@blueprintjs/core';
import styled from 'styled-components';

import {SchemaForm} from "/src/components/forms";


const _OrgSchema = {
    type: "object",
    required: ["name"],
    properties: {
        name: {
            type: "string",
            maxLength: 128
        },
        options: {
            type: "object",
            required: ["startOfWeek"],
            properties: {
                startOfWeek: { type: "string", enum: ["sunday", "monday"] },
                showSettingUpLocations: { type: "boolean", default: false },
                disableAgeAndGenderOnFrontEnd: { type: "boolean", default: false },
                ignoreLingerUnderOverride: { type: "boolean", default: false },
                isDemoUser: { type: "boolean", default: false },
                orgHasStaffDetection: { type: "boolean", default: false },
                showDemoLivePage: { type: "boolean", default: false },
                showHeadcountPlanner: { type: "boolean", default: false },
                showLivePage: { type: "boolean", default: false },
                hasInteractionHeatmaps: { type: "boolean", default: false },
                useCaptureRateV2: { type: "boolean", default: false },
            }
        }
    }
};

const _UIOrgSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Group",
            label: "Information",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/name",
                },
            ]
        },
        {
            type: "Group",
            label: "Options",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/options/properties/startOfWeek",
                },
                ...Object.keys(
                    _OrgSchema.properties.options.properties
                ).filter(key => (
                    _OrgSchema.properties.options.properties[key].type === "boolean"
                )).map(key => (
                    {
                        type: "Control",
                        scope: "#/properties/options/properties/" + key,
                        options: {
                            toggle: true
                        }
                    }
                ))
            ]
        },
    ]
};

const ContentWrapper = styled.form`
  width: 90%;
  margin: 2em auto;
  overflow: auto;
`;

const StyledButton = styled(Button)`
    display: block;
    margin: 2em auto;
`;

const CreateOrganisation = ({ isOpen, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: "",
        options: {
            startOfWeek: "monday",
            showSettingUpLocations: false,
            disableAgeAndGenderOnFrontEnd: false,
            ignoreLingerUnderOverride: false,
            isDemoUser: false,
            orgHasStaffDetection: false,
            showDemoLivePage: false,
            showHeadcountPlanner: false,
            showLivePage: false,
            hasInteractionHeatmaps: false,
            useCaptureRateV2: true,
        }
    });
    const [hasFormError, setHasFormError] = useState(false);

    return (
        <Drawer
            title="Creating an organisation"
            isOpen={isOpen}
            onClose={onClose}
            size='50%'
        >
            <ContentWrapper>
                <SchemaForm
                    schema={_OrgSchema}
                    uischema={_UIOrgSchema}
                    data={formData}
                    onChange={({ data, errors }) => {
                        setHasFormError(!!errors.length);
                        setFormData(data);
                    }}
                />
                <StyledButton
                    text="Create"
                    intent="primary"
                    fill={true}
                    disabled={hasFormError}
                    onClick={() => onSave({...formData})}
                />
            </ContentWrapper>
        </Drawer>
    );
};

export { CreateOrganisation };
